export default {
  env: 'develop',
  kibanaApi: 'https://api-support-test.xfinity.com/logger/',
};
